const useCF = (new URLSearchParams(window.location.search)).get('ws-cf') === '1';
// Cloudflare isn't used by default anymore
module.exports = {
    apiServerUrl: 'https://api-staging.amplement.io',
    publicHostname: 'https://www.staging.amplement.com',
    websocketHostname: useCF ? 'https://api-staging.amplement.io' : 'https://api.staging.amplement.com',
    debug: false,
    logLevel: 'info',
    logFilter: 'myc:*',
};
